/**
 * Function to copy any text or value to clipboard.
 */
export const copyToClipboard = (val) => {
  if (navigator && navigator.clipboard) navigator.clipboard.writeText(val);
};
